<template>
  <van-popup v-model:show="dialogVisible" position="bottom" round>
    <div class="fault-dialog">
      <div class="fd-header">
        <div class="fd-close" @click="dialogVisible = false">
          <van-icon name="cross" />
        </div>
        <div class="fd-title">编辑故障确认信息</div>
        <div class="fd-placeholder"></div>
      </div>
      <div class="fd-body">
        <div class="fault-form">
          <!-- 故障分类 -->
          <div class="ff-row" @click="onOpenFaultCascader">
            <span class="ff-label"><span class="ff-required">*</span>故障分类</span>
            <span class="ff-value" :class="{ 'ff-placeholder': !form.fault_tree_id }">
              {{ form.fault_category_name || "请选择故障分类" }}
            </span>
            <van-icon name="arrow" class="ff-arrow" />
          </div>

          <!-- 故障描述 -->
          <div class="ff-row ff-row-col">
            <span class="ff-label"><span class="ff-required">*</span>故障描述</span>
            <textarea
              v-model="form.fault_description"
              class="ff-textarea"
              rows="3"
              maxlength="500"
              placeholder="请输入故障描述"
            />
            <span class="ff-counter">{{ (form.fault_description || "").length }}/500</span>
          </div>

             <!-- 外部创建人：仅当 is_external_created=1 时显示 -->
          <div class="ff-row ff-row-col" v-if="form.is_external_created === 1">
            <span class="ff-label">验收人</span>
            <div class="external-creator-wrap">
              <EmpSelect @onSelectEmp="onSelectExternalCreator" />
            </div>
            <div class="external-creator-info" v-if="form.accept_emp_name">
              已选择：{{ form.accept_emp_code }}-{{ form.accept_emp_name }}
            </div>
          </div>
          <!-- 是否停机 -->
          <div class="ff-row">
            <span class="ff-label">是否停机</span>
            <van-switch
              :model-value="form.is_stop === 1"
              @update:model-value="(v) => (form.is_stop = v ? 1 : 0)"
              size="22px"
            />
          </div>

          <!-- 是否改善性维修 -->
          <div class="ff-row">
            <span class="ff-label">是否改善性维修</span>
            <van-switch
              :model-value="form.is_improve === 1"
              @update:model-value="(v) => (form.is_improve = v ? 1 : 0)"
              size="22px"
            />
          </div>

       

          <!-- 备注 -->
          <div class="ff-row ff-row-col">
            <span class="ff-label">备注</span>
            <textarea
              v-model="form.remark"
              class="ff-textarea"
              rows="3"
              maxlength="500"
              placeholder="请输入备注"
            />
            <span class="ff-counter">{{ (form.remark || "").length }}/500</span>
          </div>
        </div>
      </div>
      <div class="fd-footer">
        <button class="btn-secondary fd-btn" @click="dialogVisible = false">取消</button>
        <button class="btn-primary fd-btn" :disabled="submitting" @click="onSubmit">确定</button>
      </div>
    </div>

    <!-- 故障分类级联弹框 -->
    <van-popup v-model:show="showCascader" position="bottom" round>
      <van-cascader
        v-model="cascaderValue"
        title="请选择故障分类"
        :options="faultOptions"
        @close="showCascader = false"
        @finish="onCascaderFinish"
      />
    </van-popup>
  </van-popup>
</template>

<script>
import { ref, reactive, watch } from "vue";
import { Toast } from "vant";
import { GetFaultTree } from "@/api/ems/eqpInfo.js";
import EmpSelect from "@/components/Emp/empSelect.vue";

export default {
  name: "FaultConfirmDialog",
  components: { EmpSelect },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    initialData: {
      type: Object,
      default: () => ({}),
    },
    companyId: {
      type: String,
      default: "",
    },
    submitting: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:show", "confirm"],
  setup(props, { emit }) {
    const dialogVisible = ref(false);
    const showCascader = ref(false);
    const cascaderValue = ref("");
    const faultOptions = ref([]);
    const empData = reactive({
      id: '',
      emp_code: '',
      emp_name: '',
    })
    const createEmptyForm = () => ({
      id: "",
      wo_id: "",
      fault_tree_id: "",
      fault_tree_path_snapshot: "",
      fault_category_name: "",
      fault_description: "",
      is_stop: 0,
      is_improve: 0,
      is_external_created: 0,
      remark: "",
      accept_emp_name: "",
      accept_emp_id: "",
      accept_emp_code: "",
    });
    const form = reactive(createEmptyForm());

    // 父组件控制 show，打开时从 initialData 预填
    watch(
      () => props.show,
      (val) => {
        dialogVisible.value = val;
        if (val) {
          const info = props.initialData || {};
          empData.id = info.create_emp_id || "";
          empData.emp_code = info.create_emp_code || "";
          empData.emp_name = info.create_emp_name || "";

          // 先清空再逐个赋值，避免 Object.assign 在 reactive 上的覆盖问题
          const empty = createEmptyForm();
          Object.assign(form, empty);
          form.id = info.repair_extend_id || "";
          form.wo_id = info.id || "";
          form.fault_tree_id = info.fault_tree_id || "";
          form.fault_tree_path_snapshot = info.fault_tree_path_snapshot || "";
          form.fault_category_name =
          info.fault_category_name || info.fault_name || info.fault_category || "";
          form.fault_description = info.fault_description || "";
          form.is_stop = info.is_stop == 1 ? 1 : 0;
          form.is_improve = info.is_improve == 1 ? 1 : 0;
          form.is_external_created = (info.create_emp_id !== undefined && info.create_emp_id !== null && info.create_emp_id !== '') ? 0 : 1;
          form.accept_emp_id = info.external_creator_id || "";
          form.accept_emp_code = info.external_creator_code || "";
          form.accept_emp_name = info.external_creator_name || "";
          form.remark = info.remark || "";
        }
      }
    );

    watch(dialogVisible, (val) => {
      emit("update:show", val);
    });

    // 监听 is_external_created：关掉时清空已选外联人员
    watch(
      () => form.is_external_created,
      (val) => {
        if (val !== 1) {
          form.accept_emp_id = "";
          form.accept_emp_code = "";
          form.accept_emp_name = "";
        }
      }
    );

    // 映射故障树为级联结构
    const mapFaultTree = (nodes) =>
      (nodes || []).map((node) => ({
        text: node.fault_name || node.label || node.name || "",
        value: node.id || node.fault_code || "",
        children:
          node.children && node.children.length
            ? mapFaultTree(node.children)
            : undefined,
      }));

    const onOpenFaultCascader = async () => {
      if (!faultOptions.value.length) {
        try {
          const res = await GetFaultTree({ company_id: props.companyId });
          if (res.code == 200) {
            faultOptions.value = mapFaultTree(res.data || []);
          }
        } catch (e) {
          Toast("加载故障分类失败");
          return;
        }
      }
      showCascader.value = true;
    };

    const onCascaderFinish = ({ value, selectedOptions }) => {
      cascaderValue.value = value;
      form.fault_tree_id = value || "";
      form.fault_tree_path_snapshot = (selectedOptions || [])
        .map((o) => o.value)
        .join(",");
      form.fault_category_name =
        selectedOptions && selectedOptions.length
          ? selectedOptions[selectedOptions.length - 1].text
          : "";
      showCascader.value = false;
    };

    const onSubmit = () => {
      if (!form.fault_tree_id) {
        Toast("请选择故障分类");
        return;
      }
      if (!form.fault_description.trim()) {
        Toast("请填写故障描述");
        return;
      }
      if (form.is_external_created === 1 && !form.accept_emp_id) {
        Toast("请选择验收人");
        return;
      }
      // empData 为工单报修人信息，随表单一起回传父组件
      emit("confirm", { ...form, empData: { ...empData } });
    };

    // EmpSelect 回调：选中外联人员
    const onSelectExternalCreator = (item) => {
      form.accept_emp_id =item.user_id;
      form.accept_emp_code = item.emp_code ;
      form.accept_emp_name = item.emp_name;
    };

    return {
      dialogVisible,
      form,
      showCascader,
      cascaderValue,
      faultOptions,
      onOpenFaultCascader,
      onCascaderFinish,
      onSubmit,
      onSelectExternalCreator,
    };
  },
};
</script>

<style scoped lang="scss">
.fault-dialog {
  height: 80vh;
  display: flex;
  flex-direction: column;
  background: #f7f8fa;
}

.fd-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  background: #fff;
  border-bottom: 1px solid #ebedf0;
  flex-shrink: 0;

  .fd-close {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color: #86909c;
    cursor: pointer;

    &:active {
      opacity: 0.6;
    }
  }

  .fd-title {
    font-size: 16px;
    font-weight: 600;
    color: #1d2129;
  }

  .fd-placeholder {
    width: 32px;
  }
}

.fd-body {
  flex: 1;
  overflow-y: auto;
  background: #fff;
}

.fd-footer {
  flex-shrink: 0;
  display: flex;
  gap: 12px;
  padding: 10px 16px;
  padding-bottom: calc(10px + env(safe-area-inset-bottom));
  background: #fff;
  border-top: 1px solid #ebedf0;
}

.fd-btn {
  flex: 1;
}

.fault-form {
  padding: 0 16px;
}

.ff-row {
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f2f3f5;

  &.ff-row-col {
    flex-direction: column;
    align-items: stretch;
  }

  &:last-child {
    border-bottom: none;
  }

  /* 开关行：右边对齐 */
  .van-switch {
    margin-left: auto;
  }
}

.external-creator-wrap {
  border: 1px solid #ebedf0;
  border-radius: 8px;
  overflow: hidden;
  margin-top: 4px;
  max-height: 320px;
  overflow-y: auto;

  :deep(.transfer) {
    min-height: auto;

    .wrapper {
      min-height: auto;

      .title {
        padding: 8px 10px;
        font-size: 13px;
      }
    }

    .header {
      padding: 6px;
    }
  }
}

.external-creator-info {
  margin-top: 8px;
  padding: 6px 10px;
  background: #e6f7ff;
  border-radius: 6px;
  font-size: 13px;
  color: #1989fa;
}

.ff-label {
  flex-shrink: 0;
  width: 100px;
  font-size: 14px;
  color: #1d2129;
}

.ff-row-col .ff-label {
  width: auto;
  margin-bottom: 8px;
}

.ff-required {
  color: #ee0a24;
  margin-right: 2px;
}

.ff-value {
  flex: 1;
  font-size: 14px;
  color: #1d2129;
  text-align: right;

  &.ff-placeholder {
    color: #c9cdd4;
  }
}

.ff-arrow {
  margin-left: 6px;
  font-size: 12px;
  color: #c9cdd4;
}

.ff-textarea {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #e5e6eb;
  border-radius: 6px;
  font-size: 14px;
  color: #1d2129;
  resize: none;
  background: #f7f8fa;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #1989fa;
    background: #fff;
  }
}

.ff-counter {
  display: block;
  text-align: right;
  font-size: 11px;
  color: #c9cdd4;
  margin-top: 2px;
}

.ff-radios {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  gap: 16px;
}

.ff-radio {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  color: #1d2129;
  cursor: pointer;

  input {
    accent-color: #1989fa;
  }
}

.btn-primary {
  border: none;
  cursor: pointer;
  height: 44px;
  border-radius: 22px;
  background: #1989fa;
  color: #fff;
  font-size: 16px;
  font-weight: 600;

  &:active {
    background: #1578e0;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.btn-secondary {
  height: 44px;
  border-radius: 22px;
  border: 1px solid #dcdee2;
  background: #fff;
  color: #4e5969;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;

  &:active {
    background: #f2f3f5;
  }
}
</style>
